import styled from 'styled-components'

export const GlobalSearchTriggerButtonPlaceholderStyled = styled.span`
  flex: 1;
  text-align: left;
  color: ${(props) => props.theme.colors.text.placeholder};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
